import { GoverningJurisdictionType } from '../../../models/employers/employer-history/types/governing-jurisdiction-type';
import { BaseType } from '../../../models/base/base-type';

export class BeneficiarySpouseDefinitionType extends BaseType {
  public definition!: string;
  public htmlDefinition!: string;
  public governingJurisdiction!: GoverningJurisdictionType;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize?.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }
  }

  public static getSampleDefinitions(): BeneficiarySpouseDefinitionType[] {
    const data: Partial<BeneficiarySpouseDefinitionType>[] = [
      {
        id: 8,
        name: 'Federal',
        definition: `
        <div style="margin-bottom:1rem;">
          Spouse - A person who:
        </div>
        <div>
          <ul>
            <li>Is married to the member, or;</li>
            <li>Is married to the member by a marriage that is voidable and has not been annulled by a declaration of nullity, or;</li>
            <li>Etc...</li>
          </ul>
        </div>
      `,
        governingJurisdiction: { id: 10, name: 'Federal', shortCode: 'Federal' } as GoverningJurisdictionType
      },
      {
        id: 9,
        name: 'Ontario',
        definition: `
        <div style="margin-bottom:1rem;">
          Spouse - An individual who:
        </div>
        <div>
          <ul>
            <li>Has a legally recognized marriage with the member, or;</li>
            <li>Has a civil union recognized in Ontario, or;</li>
            <li>Lives with the member in a common-law relationship of at least 3 years;</li>
          </ul>
        </div>
      `,
        governingJurisdiction: { id: 20, name: 'Ontario', shortCode: 'ON' } as GoverningJurisdictionType
      },
      {
        id: 10,
        name: 'Quebec',
        definition: `
        <div style="margin-bottom:1rem;">
          Spouse - A person considered a spouse under Quebec law:
        </div>
        <div>
          <ul>
            <li>Is married to the member, or;</li>
            <li>Has a civil union with the member, or;</li>
            <li>Lives in a de facto partnership;</li>
          </ul>
        </div>
      `,
        governingJurisdiction: { id: 30, name: 'Quebec', shortCode: 'QC' } as GoverningJurisdictionType
      },
      {
        id: 11,
        name: 'British Columbia',
        definition: `
        <div style="margin-bottom:1rem;">
          Spouse - A person recognized as a spouse under BC law:
        </div>
        <div>
          <ul>
            <li>Married to the member;</li>
            <li>In a marriage that has not been annulled;</li>
            <li>In a common-law relationship of at least 2 years;</li>
          </ul>
        </div>
      `,
        governingJurisdiction: { id: 40, name: 'British Columbia', shortCode: 'BC' } as GoverningJurisdictionType
      }
    ];

    return data.map(item => {
      const instance = new BeneficiarySpouseDefinitionType();
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      instance.id = item.id!;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      instance.name = item.name!;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      instance.definition = item.definition!;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      instance.governingJurisdiction = item.governingJurisdiction!;
      return instance;
    });
  }
}
